// src/components/DegreeAudit/Overrides/RequirementOverrideSlot.tsx
// W25 lean override slice — the bridge between the audit tree and the override
// system. Reads PlanOverridesContext, so AuditRequirementDisplay only adds one
// line. Renders NOTHING when there's no provider (audit used outside the
// override-aware mount) or no requirement code — keeping the audit untouched
// everywhere the override UI isn't wired in.
import React from 'react';

import RequirementOverrideControl from './RequirementOverrideControl';
import { usePlanOverridesContext } from '../../../contexts/PlanOverridesContext';
import { OverrideDraft } from '../../../services/overrideService';

interface RequirementOverrideSlotProps {
  /** The requirement's stable id — its requirement_code. */
  code?: string;
  name?: string;
  /** Raw status: is the requirement naturally satisfied? */
  isSatisfied: boolean;
}

const RequirementOverrideSlot = ({ code, name, isSatisfied }: RequirementOverrideSlotProps) => {
  const ctx = usePlanOverridesContext();
  if (!ctx || !code) return null;

  const activeOverride = ctx.byConstraint.get(code) ?? null;
  // Nothing to show for a satisfied requirement with no override.
  if (!activeOverride && isSatisfied) return null;

  return (
    <div className="mt-1">
      <RequirementOverrideControl
        requirementCode={code}
        requirementName={name}
        isSatisfied={isSatisfied}
        activeOverride={activeOverride}
        onCreate={(draft: OverrideDraft) => ctx.createOverride(draft).then(() => undefined)}
        onRevoke={ctx.revokeOverride}
      />
    </div>
  );
};

export default RequirementOverrideSlot;
